import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../styled/constants';
import {
  BreadcrumbLink,
  BreadcrumbsSection,
  BreadcrumbText
} from '../../Ad/Sections/CurrentItemBreadcrumbs/styled';
import { tagStyles } from '../../ui/Typography/styles';
import { InfoViewsContainer } from '../../Ad/InfoViews/styled';
import { Typography } from '../../ui/Typography';

export const HeaderWrapper = styled.div`
  @media (min-width: ${Breakpoints.tablet}px) {
    display: none;
  }
`;

export const ResidenceLayout = styled.div<{ $isEmpty: boolean }>`
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    ${({ $isEmpty }) =>
      $isEmpty &&
      css`
        background-color: ${({ theme }) => theme.colors.background.primary};
      `}
  }
`;

export const ResidenceContent = styled.div`
  ${BreadcrumbsSection} {
    height: 50px;
    padding: 16px 15px;

    ${BreadcrumbLink},
    ${BreadcrumbText} {
      ${tagStyles.body_1};
    }
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    ${BreadcrumbsSection} {
      padding: 16px 40px;
      border-bottom: none;
    }
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 0 20px 100px 20px;

    ${BreadcrumbsSection} {
      padding: 16px 0;
      background-color: ${({ theme }) => theme.colors.background.tertiary};
    }
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    padding: 0 0 100px 0;
    width: 1280px;
    max-width: calc(100% - 40px);
    margin: auto;
  }
`;

export const BreadcrumbsContainer = styled.div`
  ${InfoViewsContainer} {
    display: none;
  }

  ${BreadcrumbLink} {
    &::after {
      color: ${({ theme: { colors } }) => colors.text.secondary};
    }
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondary};

    ${InfoViewsContainer} {
      display: flex;
      flex: 0 0 auto;
    }
  }
`;

export const ResidenceTitle = styled(Typography)`
  display: none;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    ${tagStyles.h8};
    display: block;
    margin: 24px 0 20px;
  }
`;

export const MainResidenceBlock = styled.div`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    background-color: ${({ theme }) => theme.colors.background.primary};
    border-radius: 14px;
    margin: 30px 0;
    padding: 40px;
    display: grid;
    grid-template-columns: 1fr 310px;
    gap: 95px;
  }
`;

export const OwnerBlockWrapper = styled.div`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    position: relative;
  }
`;

export const BottomPhoneWrapper = styled.div`
  padding: 0 15px 30px;
`;
